import React from 'react';

const SvgVc = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="VC_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="VC_svg__b" fill="#fff">
        <use xlinkHref="#VC_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#VC_svg__a" />
      <path fill="#08C47A" mask="url(#VC_svg__b)" d="M13.333 0H28v20H13.333z" />
      <path fill="#0C87E1" mask="url(#VC_svg__b)" d="M0 0h9.333v20H0z" />
      <path fill="#FECB2F" mask="url(#VC_svg__b)" d="M8 0h12v20H8z" />
      <path
        d="M14.667 8l2-4 2 4-2 4-2-4zM9.333 8l2-4 2 4-2 4-2-4zM12 13.333l2-4 2 4-2 4-2-4z"
        fill="#08C47A"
        mask="url(#VC_svg__b)"
      />
    </g>
  </svg>
);

export default SvgVc;
